import { UIHeading4 } from '@cian/ui-kit';

import { FC } from 'react';

import { CardAddressBlockContainer } from 'shared/components/CardAddressBlock';
import { CardPriceBlockContainer } from 'shared/components/CardPriceBlock';
import { useCardOfferDataContext } from 'shared/context/CardContext';

import { ErrorLogContainer } from '../ErrorLogComponent';
import { FactoidsContainer } from '../Factoids';
import { ParentCardLinkContainer } from '../ParentCardLink';
import { PublisherLabelsContainer } from '../PublisherLabels';
import { SpecialGeoListContainer } from '../SpecialGeoList';

import { CardContentTitleContainer } from './internal/components/CardContentTitle';
import { FooterFactoryContainer } from './internal/components/FooterFactory';

import styles from './CardContent.css';

export const CardContent: FC = () => {
  const { subtitle } = useCardOfferDataContext();

  return (
    <ErrorLogContainer level="error">
      <article className={styles['container']}>
        <div className={styles['block-l']}>
          <section className={styles['block-xs']}>
            <CardContentTitleContainer />
            {!!subtitle && <UIHeading4 as="h3">{subtitle}</UIHeading4>}
            <FactoidsContainer />
          </section>

          <PublisherLabelsContainer />

          <section className={styles['block-xs']}>
            <ParentCardLinkContainer />
            <SpecialGeoListContainer />
            <CardAddressBlockContainer />
          </section>

          <CardPriceBlockContainer />
        </div>

        <div className={styles['footer']}>
          <FooterFactoryContainer />
        </div>
      </article>
    </ErrorLogContainer>
  );
};
